export const GA = {
	LOGIN: {
		CATEGORY: 'Login',
		SIGN_IN_BUTTON: {
			ACTION: 'Sign In Button',
			LABEL: 'Signed in to LMDC Web App'
		},
		FORGOT_PASSWORD_LINK: {
			ACTION: 'Forgot Password Link',
			LABEL: 'Navigated to Forgot Password Page'
		},
		SIGN_IN_WITH_FB: {
			ACTION: 'Sign In With Facebook Button',
			LABEL: 'Navigated to Facebook'
		},
		SIGN_IN_WITH_GOOGLE: {
			ACTION: 'Sign In With Google Button',
			LABEL: 'Navigated to Google'
		},
		SIGN_UP: {
			ACTION: 'Sign Up Button',
			LABEL: 'Redirected to Registration Page'
		}
	},
	REGISTRATION_PAGE: {
		CATEGORY: 'Registration Page',
		ADD_PET_IMAGE: {
			ACTION: 'Upload Pet Image Button',
			LABEL: 'Uploaded Pet Image Photo'
		},
		NEXT_BUTTON: {
			ACTION: 'To Add Human Button',
			LABEL: 'Navigated to Add Human Page'
		},
		CREATE_ACCOUNT_BUTTON: {
			ACTION: 'Create Account button',
			LABEL: 'Account Created'
		},
		CREATE_ACCOUNT_WITH_FB_BUTTON: {
			ACTION: 'Created Account with Facebook',
			LABEL: 'Account Created with Facebook'
		},
		CREATE_ACCOUNT_WITH_GOOGLE_BUTTON: {
			ACTION: 'Created Account with Google',
			LABEL: 'Account Created with Google'
		}
	},
	PASSWORD_PAGE: {
		CATEGORY: 'Password',
		SET_PASSWORD_BUTTON: {
			ACTION: 'Set Password Button',
			LABEL: 'Added First Password to Account'
		},
		RESET_PASSWORD_BUTTON: {
			ACTION: 'Reset Password Button',
			LABEL: 'User Changed their password'
		},
		FORGOT_PASSWORD_VERIFY_BUTTON: {
			ACTION: 'Forgot Password Verify Email Button',
			LABEL: 'Lost Password Email Verification Sent'
		}
	},
	LANDING_PAGE: {
		CATEGORY: 'Landing Page',
		USE_WEB_APP_BUTTON: {
			ACTION: 'User Web App Button',
			LABEL: 'Navigated to Web App'
		},
		PLANS_LEARN_MORE_BUTTON: {
			ACTION: 'Plans Learn More Button',
			LABEL: 'Navigated To Plans Learn More'
		},
		GET_IT_ON_GOOGLE_PLAY: {
			ACTION: 'Get It on Google Play Button',
			LABEL: 'Redirected to Google Play Page'
		},
		GET_IT_ON_APPS_STORE: {
			ACTION: 'Get It on App Store Button',
			LABEL: 'Redirected to App Store'
		}
	},
	DASHBOARD_PAGE: {
		CATEGORY: 'Dashboard',
		SUBSCRIBE_NOW_CARDS: {
			ACTION: 'Subscribe Now Button on Cards',
			LABEL: 'Navigated to Subscription Page'
		}
	},
	TRACKING_PAGE: {
		CATEGORY: 'Tracking',
		TRACK_BUTTON: {
			ACTION: 'Tracking Button',
			LABEL: 'Filtered Date Range and Interval Report'
		}
	},
	TREATMENT_PAGE: {
		CATEGORY: 'Treatment',
		APPLY_TREATMENT_MODAL: {
			ACTION: 'Apply Treatment Modal',
			LABEL: 'Opened Apply Treatment Modal'
		},
		ADD_TREATMENT_MODAL: {
			ACTION: 'Add Treatment Modal',
			LABEL: 'Added a Treatment'
		}
	},
	NOTIFICATIONS: {
		CATEGORY: 'Notifications',
		NOTIFICATION_DROPDOWN: {
			ACTION: 'Notification Panel',
			LABEL: 'Clicked the Notification Icon in Header'
		},
		NOTIFICATION_PAGE: {
			ACTION: 'See More Link',
			LABEL: 'Navigated to Notification Page'
		}
	},
	USER_SETTINGS: {
		CATEGORY: 'User Settings',
		LOG_OUT_BUTTON: {
			ACTION: 'Log Out Button',
			LABEL: 'Redirected to Log In'
		},
		PROFILE_BUTTON: {
			ACTION: 'Profile Button',
			LABEL: 'Redirected to Profile Page'
		},
		UPGRADE_BUTTON: {
			ACTION: 'Upgrade Button',
			LABEL: 'Redirected to Subscription Page'
		},
		SETTINGS_BUTTON: {
			ACTION: 'Settings Button',
			LABEL: 'Redirected to Settings Page'
		}
	},
	DOG_PURCHASE_PAGE: {
		CATEGORY: 'Dog Purchase Page',
		REQUEST_DOG_PURCHASE_BUTTON: {
			ACTION: 'Request a dog purchase Button',
			LABEL: 'Request Dog Purchase'
		},
	},
	REQUEST_DOG_PURCHASE_PAGE: {
		CATEGORY: 'Request Dog Purchase Page',
		CANCEL_BUTTON: {
			ACTION: 'Cancel the request',
			LABEL: 'Cancel the intent to request'
		},
		REQUEST_BUTTON: {
			ACTION: 'Create a dog purchase request',
			LABEL: 'Submit the dog purchase request'
		}
	},
	REQUEST_DOG_PURCHASE_CHECK_OUT_PAGE: {
		CATEGORY: 'Request Dog Purchase Checkout Page',
		ON_PAGE_LOAD: {
			ACTION: 'User Visit Checkout Page',
			LABEL: 'User Visit Dog Purchase Checkout Page'
		},
		CHECKOUT_BUTTON: {
			ACTION: 'Checkout Button',
			LABEL: 'Purchase Product'
		}
	},
	REQUEST_DOG_PURCHASE_SUCCESS_PAGE: {
		CATEGORY: 'Request Dog Purchase Success Page',
		ON_PAGE_LOAD: {
			ACTION: 'Successfully purchase transaction',
			LABEL: 'Successfully purchase transaction'
		}
	},
	REQUEST_DOG_PURCHASE_FAILED_PAGE: {
		CATEGORY: 'Request Dog Purchase Failed Transaction Page',
		ON_PAGE_LOAD: {
			ACTION: 'Failed purchase transaction',
			LABEL: 'Failed purchase transaction'
		}
	},
	CHECKOUT_PAGE: {
		CATEGORY: 'Checkout Page',
		ERROR: 'User encounterd some error',
		ON_PAGE_LOAD: {
			ACTION: 'User Visit Checkout Page',
			LABEL: 'User Visit Checkout Page'
		},
		STORE_CREDIT_BUTTON: {
			ACTION: 'Purchase Using Store Credit',
			LABEL: 'Purchase Using Store Credit'
		},
		STRIPE_BUTTON: {
			ACTION: 'Purchase Using Credit Card',
			LABEL: 'Purchase Using Credit Card'
		},
		LATITUDE_BUTTON: {
			ACTION: 'Purchase Using LatitudePay',
			LABEL: 'Purchase Using LatitudePay'
		}
	}
}